import { createMuiTheme } from "@material-ui/core/styles"

const theme = createMuiTheme ({
	domain: "jetrails.com",
	copyright: "© <YEAR> ADF INC. ALL RIGHTS RESERVED.",
	breakpoints: {
		values: {
			lg: 1280,
			md: 800,
			sm: 600,
			xl: 1920,
			xs: 0
		}
	},
	typography: {
		fontFamily: "'Open Sans', sans-serif",
		h1: {
			fontWeight: 600,
			fontSize: "4.5rem"
		},
		h2: {
			fontWeight: 600
		},
		h3: {
			fontWeight: 600
		},
		h4: {
			fontWeight: 600
		},
		h5: {
			fontWeight: 700
		},
		h6: {
			fontWeight: 600
		}
	},
	palette: {
		primary: {
			main: "#89BA40",
			contrastText: "#000000"
		},
		secondary: {
			main: "#006FBA",
			contrastText: "#FFFFFF"
		},
		tertiary: {
			light: "#4DCCC3",
			main: "#00B7AA",
			dark: "#007F76",
			contrastText: "#FFFFFF"
		},
		gray: {
			light: "#868790",
			main: "#58595B",
			dark: "#282F38",
			contrastText: "#FFFFFF"
		},
		error: {
			main: "#DC5549",
			contrastText: "#FFFFFF"
		},
		divider: "#F3F3F3"
	},
	logo: {
		brandmark: {
			light: {
				bgColor: "#FFFFFF",
				padded: {
					svg: "/static/images/brandmark-light-padded.svg",
					png: "/static/images/brandmark-light-padded.png",
				},
				clipped: {
					svg: "/static/images/brandmark-light-clipped.svg",
					png: "/static/images/brandmark-light-clipped.png",
				},
			},
			dark: {
				bgColor: "#282F38",
				padded: {
					svg: "/static/images/brandmark-dark-padded.svg",
					png: "/static/images/brandmark-dark-padded.png",
				},
				clipped: {
					svg: "/static/images/brandmark-dark-clipped.svg",
					png: "/static/images/brandmark-dark-clipped.png",
				},
			},
		},
		wordmark: {
			light: {
				bgColor: "#FFFFFF",
				padded: {
					svg: "/static/images/wordmark-light-padded.svg",
					png: "/static/images/wordmark-light-padded.png",
				},
				clipped: {
					svg: "/static/images/wordmark-light-clipped.svg",
					png: "/static/images/wordmark-light-clipped.png",
				},
			},
			dark: {
				bgColor: "#282F38",
				padded: {
					svg: "/static/images/wordmark-dark-padded.svg",
					png: "/static/images/wordmark-dark-padded.png",
				},
				clipped: {
					svg: "/static/images/wordmark-dark-clipped.svg",
					png: "/static/images/wordmark-dark-clipped.png",
				},
			},
		},
		slogan: {
			light: {
				bgColor: "#FFFFFF",
				padded: {
					svg: "/static/images/slogan-light-padded.svg",
					png: "/static/images/slogan-light-padded.png",
				},
				clipped: {
					svg: "/static/images/slogan-light-clipped.svg",
					png: "/static/images/slogan-light-clipped.png",
				},
			},
			dark: {
				bgColor: "#282F38",
				padded: {
					svg: "/static/images/slogan-dark-padded.svg",
					png: "/static/images/slogan-dark-padded.png",
				},
				clipped: {
					svg: "/static/images/slogan-dark-clipped.svg",
					png: "/static/images/slogan-dark-clipped.png",
				},
			},
		},
		"slogan-alt": {
			light: {
				bgColor: "#FFFFFF",
				padded: {
					svg: "/static/images/slogan-alt-light-padded.svg",
					png: "/static/images/slogan-alt-light-padded.png",
				},
				clipped: {
					svg: "/static/images/slogan-alt-light-clipped.svg",
					png: "/static/images/slogan-alt-light-clipped.png",
				},
			},
			dark: {
				bgColor: "#282F38",
				padded: {
					svg: "/static/images/slogan-alt-dark-padded.svg",
					png: "/static/images/slogan-alt-dark-padded.png",
				},
				clipped: {
					svg: "/static/images/slogan-alt-dark-clipped.svg",
					png: "/static/images/slogan-alt-dark-clipped.png",
				},
			},
		},
		"autopilot-brandmark": {
			light: {
				bgColor: "#FFFFFF",
				padded: {
					svg: "/static/images/autopilot-brandmark-padded.svg",
					png: "/static/images/autopilot-brandmark-padded.png",
				},
				clipped: {
					svg: "/static/images/autopilot-brandmark-clipped.svg",
					png: "/static/images/autopilot-brandmark-clipped.png",
				},
			},
			dark: {
				bgColor: "#0B0F19",
				padded: {
					svg: "/static/images/autopilot-brandmark-padded.svg",
					png: "/static/images/autopilot-brandmark-padded.png",
				},
				clipped: {
					svg: "/static/images/autopilot-brandmark-clipped.svg",
					png: "/static/images/autopilot-brandmark-clipped.png",
				},
			},
		},
		"autopilot-wordmark": {
			light: {
				bgColor: "#FFFFFF",
				padded: {
					svg: "/static/images/autopilot-wordmark-light-padded.svg",
					png: "/static/images/autopilot-wordmark-light-padded.png",
				},
				clipped: {
					svg: "/static/images/autopilot-wordmark-light-clipped.svg",
					png: "/static/images/autopilot-wordmark-light-clipped.png",
				},
			},
			dark: {
				bgColor: "#0B0F19",
				padded: {
					svg: "/static/images/autopilot-wordmark-dark-padded.svg",
					png: "/static/images/autopilot-wordmark-dark-padded.png",
				},
				clipped: {
					svg: "/static/images/autopilot-wordmark-dark-clipped.svg",
					png: "/static/images/autopilot-wordmark-dark-clipped.png",
				},
			},
		},
		"autopilot-stacked": {
			light: {
				bgColor: "#FFFFFF",
				padded: {
					svg: "/static/images/autopilot-stacked-light-padded.svg",
					png: "/static/images/autopilot-stacked-light-padded.png",
				},
				clipped: {
					svg: "/static/images/autopilot-stacked-light-clipped.svg",
					png: "/static/images/autopilot-stacked-light-clipped.png",
				},
			},
			dark: {
				bgColor: "#0B0F19",
				padded: {
					svg: "/static/images/autopilot-stacked-dark-padded.svg",
					png: "/static/images/autopilot-stacked-dark-padded.png",
				},
				clipped: {
					svg: "/static/images/autopilot-stacked-dark-clipped.svg",
					png: "/static/images/autopilot-stacked-dark-clipped.png",
				},
			},
		},
		"jetrails-autopilot": {
			light: {
				bgColor: "#FFFFFF",
				padded: {
					svg: "/static/images/jetrails-autopilot-light-padded.svg",
					png: "/static/images/jetrails-autopilot-light-padded.png",
				},
				clipped: {
					svg: "/static/images/jetrails-autopilot-light-clipped.svg",
					png: "/static/images/jetrails-autopilot-light-clipped.png",
				},
			},
			dark: {
				bgColor: "#0B0F19",
				padded: {
					svg: "/static/images/jetrails-autopilot-dark-padded.svg",
					png: "/static/images/jetrails-autopilot-dark-padded.png",
				},
				clipped: {
					svg: "/static/images/jetrails-autopilot-dark-clipped.svg",
					png: "/static/images/jetrails-autopilot-dark-clipped.png",
				},
			},
		},
		"jetrails-autopilot-alt": {
			light: {
				bgColor: "#FFFFFF",
				padded: {
					svg: "/static/images/jetrails-autopilot-alt-light-padded.svg",
					png: "/static/images/jetrails-autopilot-alt-light-padded.png",
				},
				clipped: {
					svg: "/static/images/jetrails-autopilot-alt-light-clipped.svg",
					png: "/static/images/jetrails-autopilot-alt-light-clipped.png",
				},
			},
			dark: {
				bgColor: "#0B0F19",
				padded: {
					svg: "/static/images/jetrails-autopilot-alt-dark-padded.svg",
					png: "/static/images/jetrails-autopilot-alt-dark-padded.png",
				},
				clipped: {
					svg: "/static/images/jetrails-autopilot-alt-dark-clipped.svg",
					png: "/static/images/jetrails-autopilot-alt-dark-clipped.png",
				},
			},
		},
		"jetrails-autopilot-outlined": {
			light: {
				bgColor: "#FFFFFF",
				padded: {
					svg: "/static/images/jetrails-autopilot-outlined-light-padded.svg",
					png: "/static/images/jetrails-autopilot-outlined-light-padded.png",
				},
				clipped: {
					svg: "/static/images/jetrails-autopilot-outlined-light-clipped.svg",
					png: "/static/images/jetrails-autopilot-outlined-light-clipped.png",
				},
			},
			dark: {
				bgColor: "#0B0F19",
				padded: {
					svg: "/static/images/jetrails-autopilot-outlined-dark-padded.svg",
					png: "/static/images/jetrails-autopilot-outlined-dark-padded.png",
				},
				clipped: {
					svg: "/static/images/jetrails-autopilot-outlined-dark-clipped.svg",
					png: "/static/images/jetrails-autopilot-outlined-dark-clipped.png",
				},
			},
		},
	}
})

export default theme
